<template lang="pug">
  .year-quiz
    flip-card(
      @flip="onFlip"
      :disabled="state === states.answer || state === states.done || state === states.finished"
      )
      template(v-slot:front)
        event-card-front(
          v-if="state === states.start"
          :event="quiz.event"
          )
        card-back(v-else)
          quiz-answer(@done="result => updateState(states.done, result)")

      template(v-slot:back)
        event-card-back(
          :event="quiz.event"
          )

</template>

<script>
import FlipCard from './FlipCard'
import EventCardFront from './EventCardFront'
import EventCardBack from './EventCardBack'
import CardBack from './CardBack'
import QuizAnswer from './QuizAnswer'

const states = {
  start: 0,
  showYear: 1,
  answer: 2,
  done: 3,
  finished: 4
};

export default {
  components:{
    FlipCard,
    EventCardFront,
    EventCardBack,
    CardBack,
    QuizAnswer
  },
  props: {
    quiz: Object
  },
  data() {
    return {
      states,
      state: states.start
    };
  },
  methods: {
    onFlip({ flipped }) {
      if (flipped && this.state === this.states.start) {
        this.updateState(this.states.showYear);
      }
      if (!flipped && this.state === this.states.showYear) {
        this.updateState(this.states.answer);
      }
    },
    updateState(state, value=null) {
      if (this.state === this.states.finished) {
        return;
      }
      this.state = state;
      if (this.state === this.states.done) {
        this.$emit('done', this.quiz, value);
        this.state = this.states.finished;
      }
    }
  },
  watch: {
    quiz: function (newQuiz, oldQuiz) {
      if (newQuiz.id !== oldQuiz.id) {
        this.state = this.states.start;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
